export const SET_USER = "SET_USER";
export const SET_USER_PHOTO = "SET_USER_PHOTO";
export const SET_TOTAL_ORDERS = "SET_TOTAL_ORDERS";
export const SET_TOTAL_SALES = "SET_TOTAL_SALES";
export const SET_TOTAL_BONUSES = "SET_TOTAL_BONUSES";
export const SET_CASHBACK_PERCENT = "SET_CASHBACK_PERCENT";
